import { createSportConfig } from '../createSportConfig';
import { RacingIcon } from '../../icons/RacingIcon';

const racingConfig = createSportConfig({
    type: 'racing',

    selection: {
        noun: 'horse',
        nounPlural: 'horses',
        nounPossessive: "horse's",
        nounCapitalized: 'Horse'
    },

    event: {
        noun: 'race',
        nounPlural: 'races',
        actionNoun: 'race'
    },

    icons: {
        sportIcon: '🏇',
        SportIconComponent: RacingIcon
    },

    assets: {
        bannerImage: '/img/default-racing.jpg',
        defaultSelectionIcon: '/img/default-silk.png'
    },

    features: {
        hasUpcomingRounds: true,
        hasPlayItvCta: true
    },

    mapSelectionToCardProps: selection => ({
        clothNumber:
            (selection.metaData && selection.metaData.clothNumber) || '',
        horseName: selection.name || '-',
        jockeyName:
            (selection.metaData && selection.metaData.jockeyName) || '-',
        trainerName:
            (selection.metaData && selection.metaData.trainerName) || '-',
        silk: (selection.metaData && selection.metaData.silk) || undefined
    })
});

export default racingConfig;
